module.exports = __webpack_public_path__ + "a80a0a8fff4f45614e024eae08811325.png";